// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/realtalk'

const state = {
  init: false
}

const mutations = {
  initRealtalk: (state, bool) => {
    state.init = bool
  }
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 찐한대화 > 채팅 > 채팅 내역 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findRealtalk ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/realtalk`, payload)
  },
  /**
   * 사용자 > 찐한대화 읽음여부
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findUnreadReatalkMessage ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/unread-message`, payload)
  },
  /**
   * 사용자 > 찐한대화 > 채팅 > 채팅 내역 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findPastRealtalk ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/pastRealtalk`, payload)
  },
  /**
   * 사용자 > 찐한대화 > 채팅 > 책갈피 내역 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findBookmarkList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/bookmark`, payload)
  },

  /**
   * 사용자 > 찐한대화 > 채팅 > 채팅 일정 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findChatScheduleByUserList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/schedule/user`, payload)
  },

  /**
   * 사용자 > 찐한대화 > 채팅 > 채팅 일정 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findChatScheduleByGuideList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/schedule/guide`, payload)
  },
  /**
   * 사용자 > 찐한대화 > 채팅 > 책갈피 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async saveBookmark ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/bookmark`, payload)
  },


  /**
   * 사용자 > 찐한대화 > 채팅 > 일정 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async saveSchedule ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/schedule`, payload)
  },

    /**
   * 사용자 > 찐한대화 > 채팅 > 일정 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateSchedule ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/schedule`, payload)
  },

  /**
   * 사용자 > 찐한대화 > 채팅 > 일정 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateChatRead({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/chatRead`, payload)
  },
  /**
   * 사용자 > 찐한대화 > 찐한대화 요일 선택시, 예약 가능 시간 리스트 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async findChatScheduleByAvailableTimeList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/schedule/availableTime`, payload)
  },

}

export default { state, mutations, actions }
